module.exports = __webpack_public_path__ + "img/qy3.bd2b0d29.jpg";